import { Chip, Tooltip } from '@mui/material';

export interface SchedulePausedChipProps {
  reason?: string | null;
}

const FALLBACK = 'This schedule is paused and will not send until it is resumed.';

// The reason names the tag that broke the filter, and after the run ends it exists nowhere else the owner can look.
export const SchedulePausedChip = ({ reason }: SchedulePausedChipProps) => (
  <Tooltip title={reason || FALLBACK}>
    <Chip
      label="Paused"
      // A string tooltip title would otherwise become the accessible name and hide the state behind the reason.
      aria-label={reason ? `Paused. ${reason}` : FALLBACK}
      // A plain Chip takes no focus, which would leave the reason reachable by pointer only.
      tabIndex={0}
      size="small"
      color="warning"
      variant="outlined"
      sx={{ fontSize: '0.75rem', height: 22 }}
    />
  </Tooltip>
);
